<template>
  <v-layout align-center justify-center row class="mb-12">
    <v-flex xs12 sm10 md6 text-center>
      <div class="mb-5">
        <h1>ถ่ายรูปพัสดุ</h1>
        <v-row v-if="!hasImage">
          <v-col>
            <v-btn depressed large
                   class="mt-12"
                   height="250"
                   width="250"
                   @click='pickFile'>
              <v-icon x-large color="#546E7A">mdi-camera-plus</v-icon>
            </v-btn>
            <input type="file"
                   style="display: none"
                   ref="image"
                   accept="image/*"
                   @change="onFilePicked">
          </v-col>
        </v-row>
        <v-row justify="center" v-else>
          <v-col cols="12" align="center">
            <v-img width="250" :src="imageUrl"></v-img>
          </v-col>
          <v-col cols="12">
            <v-btn depressed large
                   @click='pickFile'>
              <v-icon x-large color="#546E7A">mdi-pencil</v-icon>
            </v-btn>
            <input type="file"
                   style="display: none"
                   ref="image"
                   accept="image/*"
                   @change="onFilePicked">
          </v-col>
        </v-row>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import EventBus from '@/EventBus'

export default {
  name: "Step2",
  data() {
    return {
      imgData: '',
      imageName: '',
      imageUrl: '',
      imageFile: '',
      hasImage: false,
    }
  },
  methods: {
    goto(route_name) {
      return this.$router.push({name: route_name})
    },
    pickFile() {
      this.$refs.image.click()
    },
    onFilePicked(e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          // console.log('onFilePicked ', fr.result)
          this.imageUrl = fr.result
          this.imageFile = files[0] // this is an image file that can be sent to server...
          let params = {step: 2, imageUrl: fr.result}
          EventBus.$emit('step_submit', params)
          this.hasImage = true
        })
      } else {
        this.imageName = ''
        this.imageFile = ''
        this.imageUrl = ''
      }
    }
  }
}
</script>

<style scoped>

</style>